import type { VenueReservationAnswer } from "@/graphql/operations";

/**
 * Maps a reservation answer to preselected values for accepted/rejected/reset.
 */
export const translateReservationAnswer =
  <Accepted, NotAccepted, Reset>([accepted, notAccepted, reset]: readonly [
    Accepted,
    NotAccepted,
    Reset,
  ]) => {
  /**
   * Translates an answer enum to one of the provided values.
   */
  return (answer: `${VenueReservationAnswer}` | null) =>
    ({
      ACCEPTED: accepted,
      NOT_ACCEPTED: notAccepted,
      RESET: reset,
    })[answer ?? "RESET"] as Accepted | NotAccepted | Reset;
  };
